import React from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'

import './Footer.sass'

export const Footer = (props) => {
  return (
    <footer id="colophon" className={props.pageName}>
      <div className="container">
        <Link className="logo" to="/" />
      </div>
    </footer>
  )
}

Footer.propTypes = {
  pageName: PropTypes.string.isRequired
}

export default Footer
